<template>

  <div>
    <div class="mainArea">
      <h1>Tags</h1>
    </div>
  </div>

</template>

<script>

export default {
  name: 'Tags'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Tags.vue